<template>
  <div class="comp-adv-filter">
    <jw-space direction="vertical" fill>
      <jw-space wrap>
        <div :class="{ 'btn-outline-wrap': num }">
          <jw-button type="outline" @click="handleClick">
            <template #icon>
              <icon-filter />
            </template>
            {{ $t('筛选') }}{{ num ? '+' + num : '' }}
            <!-- <span class="del-filter"  v-if="num"> + {{ num }}</span> -->
          </jw-button>

          <span class="del-filter" :title="$t('清空筛选条件')" v-if="num" @click.stop.prevent="clearFilter"><icon-delete /> </span>
        </div>
        <div class="jw-search-item" v-for="item in outList" :key="item.name" :class="{ 'jw-search-item-auto': item.type === 'checkbox' || item.type === 'radio' }" :style="{ width: item.width }">
          <div class="jw-search-item-label" :title="item.label" v-if="hasLabel && item.label">{{ item.label }}</div>
          <!-- 时间控件 -->
          <div v-if="item.type === 'datePicker'" class="jw-search-item-inner" :class="{ 'jw-search-item-big': isCustomDate(item) }"><xl-date-picker :subcol="item" @cb="getSearch" /></div>
          <!-- 输入框 -->
          <div v-if="item.type === 'input'" class="jw-search-item-inner"><xl-input :subcol="item" @cb="getSearch" /></div>
          <!-- select -->

          <div v-if="item.type === 'select' && entity != 16" class="jw-search-item-inner"><xl-select :subcol="item" @cb="getSearch" /></div>

          <!-- checkbox -->
          <div v-if="item.type === 'checkbox'" class="jw-search-item-inner jw-search-item-long"><xl-checkbox :subcol="item" @cb="getSearch" /></div>
          <!-- radio -->
          <div v-if="item.type === 'radio'" class="jw-search-item-inner jw-search-item-long"><xl-radio :subcol="item" @cb="getSearch" /></div>
          <!-- cascader -->
          <div v-if="item.type === 'cascader'" class="jw-search-item-inner"><xl-cascader :subcol="item" @cb="getSearch" /></div>
          <!-- treeSelect -->
          <div v-if="item.type === 'treeSelect'" class="jw-search-item-inner"><xl-tree-select :subcol="item" @cb="getSearch" /></div>
          <!-- member -->
          <div v-if="item.type === 'member'" class="jw-search-item-inner"><xl-member :subcol="item" @cb="getSearch" /></div>
          <!-- number -->
          <div v-if="item.type === 'number'" class="jw-search-item-inner"><xl-number :subcol="item" @cb="getSearch" /></div>
          <!-- 自定义 -->
          <div v-if="item.type === 'custom'" class="jw-search-item-inner" :class="{ 'jw-search-item-big': item.width === 'auto' }"><slot :name="item.name"></slot></div>
        </div>
      </jw-space>
      <!-- 已筛选的 -->
      <!-- 这里是预留的控件 -->
      <!-- {{ outWrapList }} -->
      <!-- <teleport :to="outWrap"> -->
      <div class="adv-filter-out" v-if="filterOut && num">
        <div class="adv-filter-out-inner">
          <!-- {{ advSearchDataObj }} -->
          <!-- </template>
          <template v-for="(value, key) in advSearchDataObj" :key="key"> -->
          <template v-for="key in outWrapList" :key="key">
            <!-- 1{{ value === undefined }}2 {{  key}}  v-if="value" -->
            <div class="jw-search-item">
              <div class="jw-search-item-label" v-if="advObjList[key]?.label" :title="advObjList[key]?.label">{{ advObjList[key]?.label }}</div>
              <!-- 时间控件 -->
              <div v-if="advObjList[key]?.type === 'datePicker'" class="jw-search-item-inner"><xl-date-picker :subcol="advObjList[key]" width="fiexd" @cb="outSearch" /></div>
              <!-- 输入框 -->
              <div v-if="advObjList[key]?.type === 'input'" class="jw-search-item-inner"><xl-input :subcol="advObjList[key]" @cb="outSearch" /></div>
              <!-- select -->
              <div v-if="advObjList[key]?.type === 'select'" class="jw-search-item-inner"><xl-select :subcol="advObjList[key]" @cb="outSearch" /></div>
              <!-- checkbox -->
              <div v-if="advObjList[key]?.type === 'checkbox'" class="jw-search-item-inner"><xl-select :subcol="advObjList[key]" @cb="outSearch" /></div>
              <!-- radio -->
              <div v-if="advObjList[key]?.type === 'radio'" class="jw-search-item-inner"><xl-select :subcol="advObjList[key]" @cb="outSearch" /></div>
              <!-- cascader -->
              <div v-if="advObjList[key]?.type === 'cascader'" class="jw-search-item-inner"><xl-cascader :subcol="advObjList[key]" @cb="outSearch" /></div>
              <!-- treeSelect -->
              <div v-if="advObjList[key]?.type === 'treeSelect'" class="jw-search-item-inner"><xl-tree-select :subcol="advObjList[key]" @cb="outSearch" /></div>
              <!-- member -->
              <div v-if="advObjList[key]?.type === 'member'" class="jw-search-item-inner"><xl-member :leaveStatus="leaveStatus" :subcol="advObjList[key]" @cb="outSearch" /></div>
              <!-- number -->
              <div v-if="advObjList[key]?.type === 'number'" class="jw-search-item-inner"><xl-number :subcol="advObjList[key]" @cb="outSearch" /></div>
              <!-- 自定义 -->
              <!-- <div v-if="advObjList[key]?.type === 'custom'" class="jw-search-item-inner" :class="{ 'jw-search-item-big': advObjList[key]?.width === 'auto' }"><slot :name="advObjList[key]?.name"></slot></div> -->
              <i class="icon-minus" :title="$t('清除')"><icon-minus-circle @click.prevent="clearSelf(key, advObjList[key])" /></i>
            </div>
          </template>
        </div>
        <!-- <jw-link class="adv-filter-out-clear" @click.prevent="clearFilter" title="清除全部"><icon-minus-circle class="icon-minus" />清除全部</jw-link> -->
      </div>
      <!-- </teleport> -->
    </jw-space>

    <!-- 抽屉组件 -->
    <jw-drawer :width="505" :visible="visible" @ok="handleOk" @cancel="handleCancel" class="adv-search-drawer" unmountOnClose>
      <template #title> {{ title }} </template>

      <div class="jw-search-item-wrap">
        <div class="jw-search-item" v-for="item in advList" :key="item.name" :class="{ 'jw-search-item-auto': item.type === 'checkbox' || item.type === 'radio' }">
          <div class="jw-search-item-label" :title="item.label" v-if="item.label">{{ item.label }}</div>
          <!-- 时间控件 -->
          <div v-if="item.type === 'datePicker'" class="jw-search-item-inner" :class="{ 'jw-search-item-big': isCustomDate(item) }"><xl-date-picker :subcol="{ ...item, target: '.jw-search-item-inner' }" @cb="getVal" /></div>
          <!-- 输入框 -->
          <div v-if="item.type === 'input'" class="jw-search-item-inner"><xl-input :subcol="{ ...item, target: '.jw-search-item-inner' }" @cb="getVal" /></div>
          <!-- select -->

          <div v-if="item.type === 'select'" class="jw-search-item-inner"><xl-select :subcol="{ ...item, target: '.jw-search-item-inner' }" @cb="getVal" /></div>

          <!-- checkbox -->
          <div v-if="item.type === 'checkbox'" class="jw-search-item-inner jw-search-item-long"><xl-checkbox :subcol="{ ...item, target: '.jw-search-item-inner' }" @cb="getVal" /></div>
          <!-- radio -->
          <div v-if="item.type === 'radio'" class="jw-search-item-inner jw-search-item-long"><xl-radio :subcol="{ ...item, target: '.jw-search-item-inner' }" @cb="getVal" /></div>
          <!-- cascader -->
          <div v-if="item.type === 'cascader'" class="jw-search-item-inner"><xl-cascader :subcol="{ ...item, target: '.jw-search-item-inner' }" @cb="getVal" /></div>
          <!-- treeSelect -->
          <div v-if="item.type === 'treeSelect'" class="jw-search-item-inner"><xl-tree-select :subcol="{ ...item, target: '.jw-search-item-inner' }" @cb="getVal" /></div>
          <!-- member -->
          <div v-if="item.type === 'member'" class="jw-search-item-inner"><xl-member :leaveStatus="leaveStatus" :subcol="{ ...item, target: '.jw-search-item-inner' }" @cb="getVal" /></div>
          <!-- number -->
          <div v-if="item.type === 'number'" class="jw-search-item-inner"><xl-number :subcol="{ ...item, target: '.jw-search-item-inner' }" @cb="getVal" /></div>
          <!-- 自定义 -->
          <!-- <div v-if="item.type === 'custom'" class="jw-search-item-inner" :class="{ 'jw-search-item-big': item.width === 'auto' }"><slot :name="item.name"></slot></div> -->
        </div>
        <slot></slot>
      </div>
      <!-- 抽屉 footer S -->
      <template #footer>
        <div class="adv-filter-footer">
          <jw-space><jw-switch @change="filterOutChange" v-model="filterOut" />{{ $t('搜索选项外置') }}</jw-space>
          <jw-space>
            <jw-link v-if="num" href="javascript:;" @click="clearFilter">{{ $t('清空筛选条件') }}</jw-link>
            <jw-button @click="handleCancel">{{ $t('取消') }}</jw-button>
            <jw-button type="primary" @click="handleOk">{{ $t('确定') }}</jw-button>
          </jw-space>
        </div>
      </template>
      <!-- 抽屉 footer E -->
    </jw-drawer>
  </div>
</template>

<script setup>
import XlInput from '../xl-input/xl-input.vue';
import XlSelect from '../xl-select/xl-select.vue';
import XlCheckbox from '../xl-checkbox/xl-checkbox.vue';
import XlRadio from '../xl-radio/xl-radio.vue';
import XlCascader from '../xl-cascader/xl-cascader.vue';
import XlTreeSelect from '../xl-tree-select/xl-tree-select.vue';
import XlMember from '../xl-member/xl-member.vue';
import XlNumber from '../xl-number/xl-number.vue';
import { computed, nextTick, ref, watch } from 'vue';
import i18n from '@/locales/index';
// import { useI18n } from 'vue-i18n';
// const { t } = useI18n();
const emits = defineEmits('cb');
const props = defineProps({
  hasLabel: {
    type: Boolean
  },
  outWrap: {
    type: String,
    default: '.comp-xl-search'
  },
  title: {
    type: String,
    default: i18n?.global?.t('筛选') || '筛选'
  },
  val: {
    type: Object,
    default: () => ({})
  },
  uuid: {
    // 这是当前表格搜索的唯一id
    type: String
  },
  defval: {
    type: Object,
    default: () => ({})
  },
  list: {
    type: Array,
    default: () => []
  },
  isOut: {
    type: Boolean
  },
  leaveStatus: {
    type: Number,
    default: 0
  },
  entity: {
    type: [Number, String],
    default: ''
  }
});
const storage = {
  // localStorage
  setItem(key, value) {
    if (key && value) {
      const v = JSON.stringify(value);
      localStorage.setItem(key, v);
      return value;
    }
    return value;
  },
  getItem(key) {
    let v = localStorage.getItem(key);
    if (v !== 'null' && v !== undefined) {
      v = JSON.parse(v);
    }
    return v;
  },
  removeItem(key) {
    return localStorage.removeItem(key);
  }
};
// 外置
const filterOut = ref(props.isOut || false);
// 弹出
const visible = ref(false);
// 高级搜索的结果
const advSearchDataObj = ref({});

//临时保存筛选选项值
const temporaryDataObj = ref({});
// 传入的全部搜索
const searchList = ref(props.list || []);
// 传入的默认值
const pdVal = ref(props.defval);
// 获取高级搜索的列表
const advList = computed(() => searchList.value.filter((el) => !el.out && el.type !== 'custom')); // 非外部，非自定义

// 获取外部传入的值，或者本地的值，或者自己的值
const searchDefVal = ref({});
// 外置后保存本地存储的key
const outStorgeKey = ref(`QIFEI_ADV_SEARCH_OUT_${props?.uuid}_${advList.value?.map((el) => el.name?.substr(0, 2)).join('')}_${advList.value?.length}`);

// 获取高级搜索的对象
const advObjList = ref({});
advObjList.value = advList.value.reduce((prev, cur) => {
  prev[cur.name] = cur;
  return prev;
}, {});

// 外部默认展示的，外置的
const outList = computed(() => searchList.value.filter((el) => el.out));
// 是否有自定义日期
const isCustomDate = (p) => (p?.customArray?.length && p?.customArray.find((el) => el == -1)) || !p.customArray;
// 普通搜索的结果
const searchDataObj = ref({});

// 外置的所有选项
const outWrapList = ref([]);
//外置临时所选选项
const temporaryOutWrapList = ref([]);
// 当前的数量
// const num = ref(0); Object.keys(outWrapList.value)
const num = ref(0);
// 上次选的值，去掉外置的值
const pv = computed(() => {
  const keys = Object.keys(props.val);
  const o = { ...props.val };
  outList.value.forEach((el) => {
    if (keys.indexOf(el.name) > -1) {
      delete o[el.name];
    }
  });
  return o;
});

// 初始化运行
const init = (tp) => {
  outWrapList.value = [];
  temporaryOutWrapList.value = [];
  outStorgeKey.value = `QIFEI_ADV_SEARCH_OUT_${props?.uuid}_${advList.value.map((el) => el.name.substr(0, 2)).join('')}_${advList.value.length}`;
  const item = storage.getItem(outStorgeKey.value);
  if (item?.isOut || props.isOut) {
    filterOut.value = true;
    advSearchDataObj.value = { ...(item?.val || {}), ...pdVal.value };
    temporaryDataObj.value = { ...(item?.val || {}), ...pdVal.value };
    storage.setItem(outStorgeKey.value, { isOut: true, val: advSearchDataObj.value });
    nextTick(() => {
      !tp && emits('cb', advSearchDataObj.value);
    });
  } else {
    advSearchDataObj.value = { ...pv.value, ...pdVal.value };
    temporaryDataObj.value = { ...pv.value, ...pdVal.value };
  }

  outWrapList.value = Object.keys(advSearchDataObj.value);
  temporaryOutWrapList.value = Object.keys(advSearchDataObj.value);
  num.value = outWrapList.value.length;
};
//  获取所有已保存数据的已选值
const getAllVal = () => {
  const storgeVal = storage.getItem(outStorgeKey.value) || {};
  const val = pv.value;
  const defVal = pdVal.value;
  return { ...storgeVal?.val, ...val, ...defVal };
};
searchDefVal.value = getAllVal();

// 抽屉弹出 -------------------------------------------------------------------
const handleClick = async () => {
  visible.value = true;
  // 赋值
  advSearchDataObj.value = {};
  temporaryDataObj.value = {};
  init(1);
  openVal();
  // outWrapList.value = Object.keys(advSearchDataObj.value);
};

// 抽屉弹出赋值
const openVal = () => {
  searchDefVal.value = getAllVal();
  const sdv = searchDefVal.value;
  searchList.value = props.list.map((el) => {
    // 如果是外部的 不处理值
    if (el.out) {
      return el;
    }
    // 给高级筛选的值赋值；
    if (sdv[el.name] || sdv[el.name] === 0) {
      advSearchDataObj.value[el.name] = sdv[el.name];
      temporaryDataObj.value[el.name] = sdv[el.name];
    }
    // 给组件赋值
    if (el.type === 'input') {
      el.value = sdv[el.name]?.val;
      if (el.select) {
        el.select.value = sdv[el.name]?.selectVal;
      }
    } else {
      el.value = sdv[el.name];
    }
    return el;
  });
};

// 抽屉取消
const handleCancel = () => {
  // outWrapList.value = []
  visible.value = false;
  // clearFilter()
};
// --------------------------------------------------------------------------
// 获取外置的高级搜索的值
const getAdvList = () => {
  advObjList.value = advList.value.reduce((prev, cur) => {
    // checkbox 改为select
    prev[cur.name] = { ...cur };
    // 其他赋值
    if (cur.type === 'input' || cur.type === 'number') {
      cur.value = advSearchDataObj.value[cur.name]?.val;
      if (cur.select) {
        cur.select.value = advSearchDataObj.value[cur.name]?.selectVal;
      }
    } else {
      cur.value = advSearchDataObj.value[cur.name];
    }
    return prev;
  }, {});
};

// 普通搜索回调
const getSearch = (v) => {
  const o = searchDataObj.value;
  if (v) searchDataObj.value = { ...o, ...v };
  emits('cb', searchDataObj.value);
};

// 高级搜索抽屉--单个回调
// const getVal = (val) => {
//   console.log('adv-filter', 169318, val, Object.entries(val));
//   const [[k, v]] = Object.entries(val);
//   console.log('265243adv-filter', '1169318', k, v);
//   if (v !== undefined) {
//     const o = advSearchDataObj.value;
//     if (val) {
//       advSearchDataObj.value = { ...o, ...val };
//     }
//   } else {
//     advSearchDataObj.value[k] = undefined;
//   }
//   console.log('1169318', outWrapList.value, outWrapList.value.indexOf(k), outWrapList.value.indexOf(k) === -1);
//   if (filterOut.value) {
//     storage.setItem(outStorgeKey.value, { isOut: true, val: advSearchDataObj.value });
//   }
//   // 外置空数据也得保存
//   if (outWrapList.value.indexOf(k) === -1) {
//     outWrapList.value.push(k);
//   }
//   getAdvList();
//   // console.log('116931811',outWrapList.value)
// };
const getVal = (val) => {
  const [[k, v]] = Object.entries(val);
  if (v !== undefined) {
    const o = temporaryDataObj.value;
    if (val) {
      temporaryDataObj.value = { ...o, ...val };
    }
  } else {
    temporaryDataObj.value[k] = undefined;
  }
  if (filterOut.value) {
    storage.setItem(outStorgeKey.value, { isOut: true, val: temporaryDataObj.value });
  }
  // 外置空数据也得保存
  if (temporaryOutWrapList.value.indexOf(k) === -1) {
    temporaryOutWrapList.value.push(k);
  }
};
const dealVal = () => {
  advSearchDataObj.value = temporaryDataObj.value;
  for (const i in advSearchDataObj.value) {
    if (advSearchDataObj.value[i] == undefined) {
      for (const k in temporaryOutWrapList.value) {
        if (i == temporaryOutWrapList.value[k]) {
          delete temporaryOutWrapList.value[k];
        }
      }
    }
  }
  outWrapList.value = temporaryOutWrapList.value;
  num.value = Object.keys(outWrapList.value).length;
  getAdvList();
};
// 高级搜索的确定
const handleOk = () => {
  visible.value = false;
  // console.log(445,'高级搜索的确定', advSearchDataObj.value)
  dealVal();
  // init();
  emits('cb', advSearchDataObj.value);
};

// 高级搜索--外置选项的回掉
const outSearch = (v) => {
  const o = { ...advSearchDataObj.value };
  if (v) advSearchDataObj.value = { ...o, ...v };
  if (filterOut.value) {
    if (outWrapList.value.length) {
      storage.setItem(outStorgeKey.value, { isOut: true, val: advSearchDataObj.value });
    } else {
      storage.removeItem(outStorgeKey.value);
    }
  }
  getAdvList();
  // outWrapList.value = Object.keys(advSearchDataObj.value);
  emits('cb', advSearchDataObj.value);
};
// 高级搜索外置--删除单个筛选
const clearSelf = (key, item) => {
  if (item.type === 'input' || item.type === 'number') {
    advObjList.value[key].value = undefined;
    if (advObjList.value[key].select) {
      advObjList.value[key].select.value = undefined;
    }
  } else {
    advObjList.value[key].value = undefined;
  }
  advSearchDataObj.value[key] = undefined;
  if (filterOut.value) {
    if (Object.keys(JSON.parse(JSON.stringify(advSearchDataObj.value))).length) {
      storage.setItem(outStorgeKey.value, { isOut: true, val: advSearchDataObj.value });
    } else {
      storage.removeItem(outStorgeKey.value);
    }
  }
  // 外置空数据也得保存
  const i = outWrapList.value.findIndex((el) => el === key);
  if (i > -1) {
    outWrapList.value.splice(i, 1);
  }
  temporaryOutWrapList.value = outWrapList.value;
  num.value = outWrapList.value.length;
  emits('cb', advSearchDataObj.value);
};

// 高级搜索  清除全部筛选
const clearFilter = () => {
  searchList.value = props.list.map((el) => {
    if (el.type === 'input' || el.type === 'number') {
      el.value = undefined;
      if (el.select) {
        el.select.value = undefined;
      }
    } else {
      el.value = undefined;
    }
    return el;
  });

  const v = advSearchDataObj.value;
  const o = {};
  for (const key in v) {
    if (v.hasOwnProperty.call(v, key)) {
      o[key] = undefined;
    }
  }
  advSearchDataObj.value = o;
  visible.value = false;
  filterOut.value = false;
  storage.removeItem(outStorgeKey.value);
  outWrapList.value = [];
  temporaryOutWrapList.value = [];
  temporaryDataObj.value = advSearchDataObj.value;
  num.value = outWrapList.value.length;
  emits('cb', advSearchDataObj.value);
};

// 2023-05-05 ylq  增加搜索外置保存本地的功能
// 搜索外置的
const filterOutChange = () => {
  if (filterOut.value) {
    storage.setItem(outStorgeKey.value, { isOut: true, val: advSearchDataObj.value });
  } else {
    storage.removeItem(outStorgeKey.value);
  }
};

watch(
  () => advSearchDataObj.value,
  () => {
    const keys = Object.values(advSearchDataObj.value);
    console.log('26520811', '445', keys);
    // const len = keys.filter((el) => el !== undefined);
    // num.value = len.length;
    getAdvList();
  },
  {
    deep: true
  }
);
// uuid的watch
// watch(
//   () => props.uuid,
//   () => {
//     searchDefVal.value = getAllVal();
//     searchList.value = props.list;
//     // 赋值
//     advSearchDataObj.value = {};
//     init();
//     openVal();
//   }
// );

// 列表和uuid
watch(
  () => [props.list, props.uuid],
  () => {
    outStorgeKey.value = `QIFEI_ADV_SEARCH_OUT_${props?.uuid}_${advList.value.map((el) => el.name.substr(0, 2)).join('')}_${advList.value.length}`;
    searchDefVal.value = getAllVal();
    searchList.value = props.list;
    // 赋值
    advSearchDataObj.value = {};
    init();
    openVal();
  }
);

// 默认打开本地存的值
// init();
// openVal()
</script>
<style scoped lang="less">
@import './adv-filter.less';
</style>
